/* ============================================================================
   OjaOba — Quick Cart v2  (selector + stepper on the card, bottom-sheet picker)
   - Single-option: Add to cart -> animated − N + stepper
   - Variant: tap selector -> slide-up sheet -> pick size -> Add -> stepper.
     Switching size reflects THAT variant's real cart quantity.
   Self-contained. Purple only (no gold). Drawer never auto-opens.
   ============================================================================ */
(function () {
  'use strict';
  if (!window.theme || !theme.routes || !theme.routes.cart_add_url || !theme.routes.cart_change_url) return;

  var ADD_URL = theme.routes.cart_add_url;
  var CHANGE_URL = theme.routes.cart_change_url;
  var CART_JS = (theme.routes.cart_url || '/cart') + '.js';

  var SECTIONS = ['cart-drawer', 'cart-bubble', 'main-cart'];
  var SECTION_MAP = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' },
    { id: 'Cart',               section: 'main-cart',   selector: '.thb-cart-form' }
  ];

  var ICON_MINUS = '−'; // −
  var ICON_PLUS  = '+';

  var CART = {}; // variantId(string) -> qty

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function absorbCart(res) {
    if (res && Array.isArray(res.items)) {
      CART = {};
      res.items.forEach(function (it) { CART[String(it.id)] = (CART[String(it.id)] || 0) + it.quantity; });
    }
  }

  function renderSections(res) {
    if (!res || !res.sections) return;
    SECTION_MAP.forEach(function (s) {
      var container = document.getElementById(s.id);
      if (!container || !res.sections[s.section]) return;
      var fresh = new DOMParser().parseFromString(res.sections[s.section], 'text/html').querySelector(s.selector);
      var target = container.querySelector(s.selector) || container;
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    });
  }

  /* ---- Pop-up sheet: lists each variant with its own +/- stepper ---- */
  function createSheet() {
    var backdrop = document.createElement('div');
    backdrop.className = 'oja-sheet-backdrop';
    backdrop.innerHTML =
      '<div class="oja-sheet">' +
        '<button type="button" class="oja-sheet-close" aria-label="Close">×</button>' +
        '<div class="oja-sheet-title"></div>' +
        '<div class="oja-sheet-sub">Select your preferred option</div>' +
        '<div class="oja-sheet-rows"></div>' +
      '</div>';
    document.body.appendChild(backdrop);
    var titleEl = backdrop.querySelector('.oja-sheet-title');
    var rowsEl = backdrop.querySelector('.oja-sheet-rows');
    function close() { backdrop.classList.remove('open'); }
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); });
    backdrop.querySelector('.oja-sheet-close').addEventListener('click', close);

    function renderCtl(ctl, v, onChange) {
      ctl.innerHTML = '';
      var q = CART[v.id] || 0;
      if (!v.available) {
        var soldOut = document.createElement('span');
        soldOut.className = 'oja-soldout-pill';
        soldOut.textContent = 'Sold out';
        ctl.appendChild(soldOut);
        return;
      }
      if (q > 0) {
        ctl.appendChild(makeStepper(v.id, q, function () { renderCtl(ctl, v, onChange); if (onChange) onChange(); }));
      } else {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oja-plus-btn';
        b.setAttribute('aria-label', 'Add ' + v.label);
        b.textContent = '+';
        b.addEventListener('click', function () {
          b.disabled = true;
          post(ADD_URL, { id: v.id, quantity: 1, sections: SECTIONS, sections_url: window.location.pathname })
            .then(function (res) {
              if (res && res.status) {
                // Shopify itself rejected the add (e.g. stock ran out between
                // page load and this click) — reflect that instead of
                // silently leaving a live-looking "+" button that does nothing.
                v.available = false;
                renderCtl(ctl, v, onChange);
                return;
              }
              CART[v.id] = (CART[v.id] || 0) + 1;
              renderSections(res);
              renderCtl(ctl, v, onChange);
              if (onChange) onChange();
            })
            .catch(function () { b.disabled = false; });
        });
        ctl.appendChild(b);
      }
    }

    function openProduct(name, variants, onChange) {
      titleEl.textContent = name;
      rowsEl.innerHTML = '';
      variants.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'oja-sheet-row2' + (v.available ? '' : ' oja-sheet-row2--soldout');
        var media = v.img ? '<img class="oja-sheet-thumb" src="' + esc(v.img) + '" alt="">' : '<span class="oja-sheet-thumb"></span>';
        row.innerHTML = media +
          '<div class="oja-sheet-info"><div class="oja-sheet-price">' + esc(v.price) + '</div><div class="oja-sheet-label">' + esc(v.label) + '</div></div>' +
          '<div class="oja-sheet-ctl"></div>';
        renderCtl(row.querySelector('.oja-sheet-ctl'), v, onChange);
        rowsEl.appendChild(row);
      });
      backdrop.classList.add('open');
    }
    return { openProduct: openProduct, close: close };
  }
  var SHEET = null;

  /* ---- Stepper factory: returns an element wired to the cart for `variantId` ---- */
  function makeStepper(variantId, qty, onZero) {
    var el = document.createElement('div');
    el.className = 'oja-stepper';
    el.innerHTML =
      '<button type="button" class="oja-stepper__btn oja-stepper__minus" aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
      '<input class="oja-stepper__input" type="text" inputmode="numeric" pattern="[0-9]*" aria-label="Quantity">' +
      '<button type="button" class="oja-stepper__btn oja-stepper__plus" aria-label="Increase quantity">' + ICON_PLUS + '</button>';
    var input = el.querySelector('.oja-stepper__input');
    var st = { qty: qty, pending: null };
    input.value = qty;

    function setQty(q) {
      if (q < 0) q = 0;
      if (q === 0) { el.remove(); if (onZero) onZero(); }
      else { st.qty = q; input.value = q; }
      if (st.pending) clearTimeout(st.pending);
      st.pending = setTimeout(function () {
        post(CHANGE_URL, { id: variantId, quantity: q, sections: SECTIONS, sections_url: window.location.pathname })
          .then(function (res) {
            absorbCart(res);
            var actual = CART[variantId] || 0;
            if (actual <= 0) { el.remove(); if (onZero) onZero(); }
            else { st.qty = actual; input.value = actual; }
            renderSections(res);
          }).catch(function () {});
      }, 350);
    }
    el.querySelector('.oja-stepper__plus').addEventListener('click', function () { setQty(st.qty + 1); });
    el.querySelector('.oja-stepper__minus').addEventListener('click', function () { setQty(st.qty - 1); });
    input.addEventListener('change', function () { var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) v = 0; setQty(v); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    // pop animation on next frame
    requestAnimationFrame(function () { el.classList.add('oja-pop'); });
    return el;
  }

  /* ---- Single-option products ---- */
  function enhanceSimple(button) {
    if (button.__oja) return;
    button.__oja = true;
    var vid = button.dataset.productId;
    if (!vid) return;
    var container = button.parentNode;

    function showStepper(q) {
      button.style.display = 'none';
      var old = container.querySelector('.oja-stepper'); if (old) old.remove();
      var st = makeStepper(vid, q, function () { button.style.display = ''; });
      button.insertAdjacentElement('afterend', st);
    }
    button.addEventListener('click', function (e) {
      if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      button.classList.add('loading');
      post(ADD_URL, { id: vid, quantity: 1, sections: SECTIONS, sections_url: window.location.pathname })
        .then(function (res) {
          button.classList.remove('loading');
          if (res && res.status) return;
          CART[vid] = (CART[vid] || 0) + 1;
          renderSections(res);
          showStepper(CART[vid] || 1);
        }).catch(function () { button.classList.remove('loading'); });
    }, true);

    button.__ojaReflect = function () { if ((CART[vid] || 0) > 0) showStepper(CART[vid]); };
  }

  /* ---- Variant products: ONE "Options" button -> sheet with per-variant steppers ---- */
  function enhanceVariant(dropdown) {
    if (dropdown.__oja) return;
    dropdown.__oja = true;
    var variants = qsa('.variant-option', dropdown).map(function (o) {
      var spans = o.querySelectorAll('span');
      var img = o.querySelector('img');
      return {
        id: String(o.dataset.variantId),
        label: spans[0] ? spans[0].textContent.trim() : 'Option',
        price: spans[1] ? spans[1].textContent.trim() : '',
        img: img ? img.getAttribute('src') : '',
        available: o.dataset.available !== 'false'
      };
    });
    if (!variants.length) return;
    dropdown.style.display = 'none';

    var card = dropdown.closest('product-card, .product-card');
    var titleEl = card ? card.querySelector('.product-card-title') : null;
    var productName = titleEl ? titleEl.textContent.trim() : 'Choose an option';

    var wrap = document.createElement('div');
    wrap.className = 'oja-variant';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oja-selector';
    wrap.appendChild(btn);
    dropdown.insertAdjacentElement('afterend', wrap);

    function label() {
      var total = variants.reduce(function (a, v) { return a + (CART[v.id] || 0); }, 0);
      return total > 0 ? ('Options · ' + total) : 'Options';
    }
    function render() {
      btn.innerHTML = '<span class="oja-selector__label">' + label() + '</span><span class="oja-selector__chev">▾</span>';
    }
    render();
    btn.addEventListener('click', function () { SHEET.openProduct(productName, variants, render); });

    this.reflect = render;
  }

  function init() {
    if (!SHEET) SHEET = createSheet();

    var simples = qsa('.product-card--add-to-cart-button-simple');
    simples.forEach(enhanceSimple);

    var variantControllers = [];
    qsa('.variant-dropdown').forEach(function (dd) {
      if (dd.__oja) return;
      var c = new enhanceVariant(dd);
      if (c && c.reflect) variantControllers.push(c);
    });

    fetch(CART_JS, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        absorbCart(cart);
        simples.forEach(function (b) { if (b.__ojaReflect) b.__ojaReflect(); });
        variantControllers.forEach(function (c) { c.reflect(); });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
